module.exports = __webpack_public_path__ + "static/assets/3d6b4e16e4c093dbce2321b46560325e.png";